import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import CustomLoader from "../../../../components/CustomLoader";
import { fileImageView, noImageFound } from "../atoms/atoms";

const OfficeFileImageView = ({ officeImage, imageName }) => {
  const imageView = useRecoilValue(fileImageView);
  const noImage = useRecoilValue(noImageFound);
  const [officeImageData, setOfficeImageData] = useState<any>([]);

  useEffect(() => {
    if (officeImage) {
      setOfficeImageData(
        officeImage.filter((x) => x.fileImageName === imageName)
      );
    }
  }, []);

  return (
    <>
      {officeImageData &&
        officeImageData?.map((data) => {
          // Remove the office code from the fileImageName
          const fileImageName = data.fileImageName?.replace(
            `${data.officeCode}-`,
            ""
          );
          return (
            <div className="w-full">
              <div className="flex items-center space-x-2 px-4">
                <div className="w-full col-span-1 border-b-4 border-secondary text-sm">
                  <div className="text-primary font-medium font-sans py-2 px-1">
                    {fileImageName.split(".").slice(0, -1).join(".")}
                  </div>
                  <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-5 pb-2">
                    <div className="flex flex-row-2 mr-5 gap-1">
                      <div className="font-normal px-1">Image Category:</div>
                      <span className="font-medium">
                        {data.imageCategoryName}
                      </span>
                    </div>
                    <div className="flex flex-row-2 ml-8 pl-10 gap-1">
                      <div className="font-normal px-1">Image Label:</div>
                      <span className="font-medium">{data.imageLabelName}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-1 justify-items-center py-4 px-4">
                {imageView === "" && noImage === "" ? (
                  <CustomLoader />
                ) : (
                  <img
                    src={imageView}
                    alt={
                      noImage === "ImageNotFound" ? "Image not found!" : "Image"
                    }
                  />
                )}
              </div>
            </div>
          );
        })}
    </>
  );
};

export default OfficeFileImageView;
